export const translations = {
  tr: {
    // Genel
    home: 'Ana Sayfa',
    vehicles: 'Araçlar',
    reservation: 'Rezervasyon',
    contact: 'İletişim',
    language: 'Dil',
    loading: 'Yükleniyor',
    error: 'Bir hata oluştu',

    // Anasayfa
    welcomeTitle: 'Korsan Taksi Hizmetimize Hoş Geldiniz',
    welcomeSubtitle: 'En uygun fiyatlarla kaliteli ve güvenli Korsan Taksi deneyimi',
    welcomeNote: 'Tüm araçlarımız 2022 model ve üstüdür.',
    contactForPrice: 'Fiyat için sizinle iletişime geçilecektir',
    exploreVehicles: 'WhatsApp',
    whyChooseUs: 'Neden Bizi Seçmelisiniz?',
    affordablePrices: 'Uygun Fiyatlar',
    affordablePricesDesc: 'Saatlik kiralama ile bütçenize uygun seçenekler',
    qualityVehicles: 'Kaliteli Araçlar',
    qualityVehiclesDesc: 'Düzenli bakımlı ve temiz araçlar',
    easyBooking: 'Kolay Rezervasyon',
    easyBookingDesc: 'Üye olmadan hızlı ve kolay rezervasyon',
    support247: '7/24 Destek',
    support247Desc: 'Her zaman yanınızdayız',

    // Araç Listesi
    availableVehicles: 'Müsait Araçlar',
    perHour: 'saat',
    viewDetails: 'Detayları Gör',
    bookNow: 'Rezervasyon Yap',
    noVehicles: 'Şu anda müsait araç bulunmamaktadır',
    selectVehicle: 'Bir araç seçin',

    // Araç Detay
    vehicleDetails: 'Araç Detayları',
    description: 'Açıklama',
    aboutVehicle: 'Araç Hakkında',
    hourlyRate: 'Saatlik Ücret',
    dailyRate: 'Günlük Ücret',
    hour: 'saat',
    day: 'gün',
    available: 'Müsait',
    notAvailable: 'Müsait Değil',
    backToVehicles: 'Araçlara Dön',

    // Rezervasyon Formu
    reservationForm: 'Rezervasyon Formu',
    personalInfo: 'Kişisel Bilgiler',
    fullName: 'Ad Soyad',
    phone: 'Telefon',
    email: 'E-posta',
    reservationDetails: 'Rezervasyon Detayları',
    pickupLocation: 'Nereden (Alınış)',
    dropoffLocation: 'Nereye (Bırakılış)',
    date: 'Tarih',
    startTime: 'Başlangıç Saati',
    duration: 'Süre',
    hours: 'saat',
    totalPrice: 'Toplam Ücret',
    completeReservation: 'Rezervasyonu Tamamla',
    reservationSuccess: 'Rezervasyonunuz başarıyla oluşturuldu!',
    reservationError: 'Rezervasyon oluşturulurken bir hata oluştu',
    confirmationEmail: 'Rezervasyon detayları e-posta adresinize gönderilecektir',

    // Validasyon Mesajları
    required: 'Bu alan zorunludur',
    invalidEmail: 'Geçerli bir e-posta adresi girin',
    invalidPhone: 'Geçerli bir telefon numarası girin',
    selectDate: 'Lütfen tarih seçin',
    selectTime: 'Lütfen saat seçin',
    selectDuration: 'Lütfen süre seçin',

    // Footer
    allRightsReserved: 'Tüm hakları saklıdır',
    privacyPolicy: 'Gizlilik Politikası',
    termsOfService: 'Kullanım Koşulları',

    // WhatsApp
    chatOnWhatsApp: 'WhatsApp\'tan Mesaj Gönderin',
    callUs: 'Bizi Ara'
  },

  en: {
    // General
    home: 'Home',
    vehicles: 'Vehicles',
    reservation: 'Reservation',
    contact: 'Contact',
    language: 'Language',
    loading: 'Loading',
    error: 'An error occurred',

    // Homepage
    welcomeTitle: 'Welcome to Our Illegal Taxi Service',
    welcomeSubtitle: 'Quality and safe Illegal Taxi experience at affordable prices',
    welcomeNote: 'All our vehicles are 2022 model and above.',
    contactForPrice: 'You will be contacted for the price',
    exploreVehicles: 'WhatsApp',
    whyChooseUs: 'Why Choose Us?',
    affordablePrices: 'Affordable Prices',
    affordablePricesDesc: 'Budget-friendly options with hourly rental',
    qualityVehicles: 'Quality Vehicles',
    qualityVehiclesDesc: 'Well-maintained and clean vehicles',
    easyBooking: 'Easy Booking',
    easyBookingDesc: 'Quick and easy reservation without membership',
    support247: '24/7 Support',
    support247Desc: 'Always here for you',

    // Vehicle List
    availableVehicles: 'Available Vehicles',
    perHour: 'hour',
    viewDetails: 'View Details',
    bookNow: 'Book Now',
    noVehicles: 'No vehicles available at the moment',
    selectVehicle: 'Select a vehicle',

    // Vehicle Details
    vehicleDetails: 'Vehicle Details',
    description: 'Description',
    aboutVehicle: 'About Vehicle',
    hourlyRate: 'Hourly Rate',
    dailyRate: 'Daily Rate',
    hour: 'hour',
    day: 'day',
    available: 'Available',
    notAvailable: 'Not Available',
    backToVehicles: 'Back to Vehicles',

    // Reservation Form
    reservationForm: 'Reservation Form',
    personalInfo: 'Personal Information',
    fullName: 'Full Name',
    phone: 'Phone',
    email: 'Email',
    reservationDetails: 'Reservation Details',
    pickupLocation: 'Pick-up Location',
    dropoffLocation: 'Drop-off Location',
    date: 'Date',
    startTime: 'Start Time',
    duration: 'Duration',
    hours: 'hours',
    totalPrice: 'Total Price',
    completeReservation: 'Complete Reservation',
    reservationSuccess: 'Your reservation has been successfully created!',
    reservationError: 'An error occurred while creating the reservation',
    confirmationEmail: 'Reservation details will be sent to your email',

    // Validation Messages
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    selectDate: 'Please select a date',
    selectTime: 'Please select a time',
    selectDuration: 'Please select duration',

    // Footer
    allRightsReserved: 'All rights reserved',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',

    // WhatsApp
    chatOnWhatsApp: 'Chat on WhatsApp',
    callUs: 'Call Us'
  },

  ru: {
    // Общее
    home: 'Главная',
    vehicles: 'Транспорт',
    reservation: 'Бронирование',
    contact: 'Контакты',
    language: 'Язык',
    loading: 'Загрузка',
    error: 'Произошла ошибка',

    // Главная страница
    welcomeTitle: 'Добро пожаловать в нашу службу Нелегальное Такси',
    welcomeSubtitle: 'Качественная и безопасная аренда автомобилей по доступным ценам',
    welcomeNote: 'Все наши автомобили 2022 года выпуска и новее.',
    contactForPrice: 'С вами свяжутся для уточнения цены',
    exploreVehicles: 'WhatsApp',
    whyChooseUs: 'Почему мы?',
    affordablePrices: 'Доступные цены',
    affordablePricesDesc: 'Бюджетные варианты с почасовой арендой',
    qualityVehicles: 'Качественный транспорт',
    qualityVehiclesDesc: 'Ухоженные и чистые транспортные средства',
    easyBooking: 'Легкое бронирование',
    easyBookingDesc: 'Быстрое бронирование без регистрации',
    support247: 'Поддержка 24/7',
    support247Desc: 'Всегда рядом с вами',

    // Список транспорта
    availableVehicles: 'Доступный транспорт',
    perHour: 'час',
    viewDetails: 'Подробнее',
    bookNow: 'Забронировать',
    noVehicles: 'В данный момент транспорт недоступен',
    selectVehicle: 'Выберите транспорт',

    // Детали транспорта
    vehicleDetails: 'Детали транспорта',
    description: 'Описание',
    aboutVehicle: 'О транспорте',
    hourlyRate: 'Почасовая ставка',
    dailyRate: 'Дневная ставка',
    hour: 'час',
    day: 'день',
    available: 'Доступно',
    notAvailable: 'Недоступно',
    backToVehicles: 'Назад к транспорту',

    // Форма бронирования
    reservationForm: 'Форма бронирования',
    personalInfo: 'Личная информация',
    fullName: 'Полное имя',
    phone: 'Телефон',
    email: 'Электронная почта',
    reservationDetails: 'Детали бронирования',
    pickupLocation: 'Место посадки',
    dropoffLocation: 'Место высадки',
    date: 'Дата',
    startTime: 'Время начала',
    duration: 'Продолжительность',
    hours: 'часов',
    totalPrice: 'Общая стоимость',
    completeReservation: 'Завершить бронирование',
    reservationSuccess: 'Ваше бронирование успешно создано!',
    reservationError: 'Произошла ошибка при создании бронирования',
    confirmationEmail: 'Детали бронирования будут отправлены на вашу электронную почту',

    // Сообщения валидации
    required: 'Это поле обязательно',
    invalidEmail: 'Введите действительный адрес электронной почты',
    invalidPhone: 'Введите действительный номер телефона',
    selectDate: 'Пожалуйста, выберите дату',
    selectTime: 'Пожалуйста, выберите время',
    selectDuration: 'Пожалуйста, выберите продолжительность',

    // Футер
    allRightsReserved: 'Все права защищены',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',

    // WhatsApp
    chatOnWhatsApp: 'Написать в WhatsApp',
    callUs: 'Позвонить нам'
  },

  ar: {
    // عام
    home: 'الرئيسية',
    vehicles: 'المركبات',
    reservation: 'الحجز',
    contact: 'اتصل بنا',
    language: 'اللغة',
    loading: 'جاري التحميل',
    error: 'حدث خطأ',

    // الصفحة الرئيسية
    welcomeTitle: 'مرحباً بكم في خدمة تاكسي غير قانوني',
    welcomeSubtitle: 'تجربة تأجير سيارات آمنة وعالية الجودة بأسعار معقولة',
    welcomeNote: 'جميع سياراتنا موديل 2022 وما فوق.',
    contactForPrice: 'سيتم الاتصال بك لمعرفة السعر',
    exploreVehicles: 'WhatsApp',
    whyChooseUs: 'لماذا نحن؟',
    affordablePrices: 'أسعار معقولة',
    affordablePricesDesc: 'خيارات ملائمة للميزانية مع التأجير بالساعة',
    qualityVehicles: 'مركبات عالية الجودة',
    qualityVehiclesDesc: 'مركبات نظيفة ومُصانة بشكل جيد',
    easyBooking: 'حجز سهل',
    easyBookingDesc: 'حجز سريع وسهل بدون عضوية',
    support247: 'دعم 24/7',
    support247Desc: 'دائماً معك',

    // قائمة المركبات
    availableVehicles: 'المركبات المتاحة',
    perHour: 'ساعة',
    viewDetails: 'عرض التفاصيل',
    bookNow: 'احجز الآن',
    noVehicles: 'لا توجد مركبات متاحة في الوقت الحالي',
    selectVehicle: 'اختر مركبة',

    // تفاصيل المركبة
    vehicleDetails: 'تفاصيل المركبة',
    description: 'الوصف',
    aboutVehicle: 'عن المركبة',
    hourlyRate: 'السعر بالساعة',
    dailyRate: 'السعر اليومي',
    hour: 'ساعة',
    day: 'يوم',
    available: 'متاح',
    notAvailable: 'غير متاح',
    backToVehicles: 'العودة إلى المركبات',

    // نموذج الحجز
    reservationForm: 'نموذج الحجز',
    personalInfo: 'المعلومات الشخصية',
    fullName: 'الاسم الكامل',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    reservationDetails: 'تفاصيل الحجز',
    pickupLocation: 'موقع الاستلام',
    dropoffLocation: 'موقع التسليم',
    date: 'التاريخ',
    startTime: 'وقت البدء',
    duration: 'المدة',
    hours: 'ساعات',
    totalPrice: 'السعر الإجمالي',
    completeReservation: 'إتمام الحجز',
    reservationSuccess: 'تم إنشاء حجزك بنجاح!',
    reservationError: 'حدث خطأ أثناء إنشاء الحجز',
    confirmationEmail: 'سيتم إرسال تفاصيل الحجز إلى بريدك الإلكتروني',

    // رسائل التحقق
    required: 'هذا الحقل مطلوب',
    invalidEmail: 'الرجاء إدخال عنوان بريد إلكتروني صالح',
    invalidPhone: 'الرجاء إدخال رقم هاتف صالح',
    selectDate: 'الرجاء اختيار التاريخ',
    selectTime: 'الرجاء اختيار الوقت',
    selectDuration: 'الرجاء اختيار المدة',

    // التذييل
    allRightsReserved: 'جميع الحقوق محفوظة',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',

    // واتساب
    chatOnWhatsApp: 'راسلنا على واتساب',
    callUs: 'اتصل بنا'
  }
};

// Tarayıcı dilini algıla
export const detectLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();

  const supportedLanguages = ['tr', 'en', 'ru', 'ar'];

  if (supportedLanguages.includes(langCode)) {
    return langCode;
  }

  return 'en'; // Varsayılan dil
};

// Çeviri fonksiyonu
export const translate = (key, lang) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};
